import validator from "@/locales/languages/es_MX/view/filetransaction/validator";
import importer from "@/locales/languages/es_MX/view/filetransaction/importer";

export default {
  validator
  , importer
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/filetransaction/index.js